import axios from "axios";
import VueCookie from "vue-cookie"
import AWS_demo from '@/resources/AWS_demo.js'
import hash from "object-hash"
import store from "@/store/store.js"

let API_with_auth_demo = axios.create({
    withCredentials: true,
    baseURL: `https://pp3.skarb.club`,
    // baseURL: `http://127.0.0.1:8888/`,
    headers: {
        Authorization: {
            toString() {
                return `Bearer ${VueCookie.get("id_token_demo")}`
            }
        }
    }
})

API_with_auth_demo.interceptors.response.use(null, function(error) {
    const originalRequest = error.config;
    const response = error.response;

    if (response.status === 401) {
        // if (true) {
        return AWS_demo.getNewTokensDemo().
        then(() => {
                // replace the expired token and retry
                originalRequest.headers['Authorization'] = `Bearer ${VueCookie.get("id_token_demo")}`;
                return Promise.resolve(axios(originalRequest));
            })
            .catch(error => {
                console.log(error);
            })
    }
    return Promise.reject(error)
})

export default {
    GetTableData(params) {
        let URL = '/view/slice/'

        return API_with_auth_demo.post(URL, {
            ...params,
        })
    },
    GetChartData(params) {
        let URL = '/view/history/'

        return API_with_auth_demo.post(URL, {
            ...params,
        })
    },
    GetMeta() {
        return API_with_auth_demo.get('/view/meta/')
    },
    GetState(stateId) {
        return API_with_auth_demo.get('/states/' + stateId)
    },
    SaveUpcomingState(state, prevHash) {
        let newHash = hash(state)
        if (newHash === prevHash) return
        this.saveState(state)
            .then(response => {
                store.commit('updateState', {
                    hash: newHash,
                    stateId: response.data.state_id,
                })
                //TODO: this causing reload
                // router.push({
                //     name: 'overvieww',
                //     params: {
                //         state_id: response.data.state_id
                //     }
                // }).catch(() => {})
                history.pushState({},
                    null,
                    "/overview/" + response.data.state_id
                )
            })
            .catch(error => {
                console.log(error.response);
            })
    },
    saveState(params) {
        let URL = '/states/'

        return API_with_auth_demo.post(URL, {
            ...params,
        })
    },
}